
























import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component

export default class ComponenteBackofficeTipoLesao extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getItensLesao() {
    return this.getBackofficeGlobalStore.solicitacao.lesoes
  }

  headers = [
    { text: 'Lesão', value: 'descricao' },
    { text: 'Quantidade', value: 'quantidade' },
  ]
}
